import { useLayoutEffect, useRef } from 'react';
export function useFocusControl(isOpen) {
    var toggleRef = useRef(null);
    var closeRef = useRef(null);
    useLayoutEffect(function () {
        var _a, _b;
        if (isOpen) {
            (_a = closeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = toggleRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [isOpen]);
    return { toggle: toggleRef, close: closeRef };
}
